/**
 * @generated SignedSource<<5a1bbaacb22de91c41393e0f57bf532a>>
 * @relayHash f78b30b527a41deb1bb7a874bc02b6fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 31f7b7d27283411126fe5e642243fffc919d6cb39181666ed125257959dd5c03

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getPeoplePropsQuery$variables = {
  cloudId: string;
  suggestedUsersCount?: number | null | undefined;
};
export type getPeoplePropsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedUsers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly user: {
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly suggestedGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
  readonly me: {
    readonly user: {
      readonly picture: AGG$URL;
    } | null | undefined;
  };
};
export type getPeoplePropsQuery = {
  response: getPeoplePropsQuery$data;
  variables: getPeoplePropsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suggestedUsersCount"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "picture"
},
v2 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "suggestedUsersCount"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 5
    }
  ],
  "concreteType": "JiraJqlGroupFieldValueConnection",
  "kind": "LinkedField",
  "name": "suggestedGroups",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraJqlGroupFieldValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraJqlGroupFieldValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v6/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "suggestedGroups(first:5)"
},
v8 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getPeoplePropsQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v3/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "concreteType": "JiraJqlUserFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedUsers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlUserFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlUserFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/),
                            (v6/*: any*/),
                            (v2/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                },
                (v7/*: any*/)
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getPeoplePropsQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraJqlUserFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedUsers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlUserFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlUserFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "31f7b7d27283411126fe5e642243fffc919d6cb39181666ed125257959dd5c03",
    "metadata": {},
    "name": "getPeoplePropsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d4c27342cff5973fb3237028f4ad9211";

export default node;
